VjsAdmin.LicenseUsers = (function () {
    const me = {};

    me.$users_table = $('#users-table');
    me.platform_id = me.$users_table.attr('data-platform-id');
    me.district_joint_guid = me.$users_table.attr('data-district-joint-guid');
    me.license_id = me.$users_table.attr('data-license-id');
    me.users_table_height = window.innerHeight * 0.85;

    // include usage stuffs
    me.users_include_usage = 0;
    me.users_date_range_from = null;
    me.users_date_range_to = null;

    // bulk edit stuffs
    me.bulk_delete_max = 500;
    me.selections = [];
    me.$bulk_edit_modal = null;
    me.$bulk_edit_response_modal = null;
    me.licenses_order_by = 'license_id';
    me.licenses_sort_order = 'desc';
    me.licenses_table_height = window.innerHeight * 0.55;

    me.usersTableQueryParams = function (params) {
        const myParams = VjsTable.tableDefaults().queryParams.call(this, params);

        switch (this.search_roles) {
            case null:
                myParams.admins_only = null;
                myParams.users_only = null;
                myParams.role_id = null;
                break;
            case 'admins':
                myParams.admins_only = 1;
                break;
            case 'users':
                myParams.users_only = 1;
                break;
            default:
                myParams.role_id = this.search_roles;
                break;
        }

        myParams.active = this.search_active;
        myParams.include_usage = me.users_include_usage;
        myParams.date_range_from = me.users_date_range_from == null ? null : me.users_date_range_from.format();
        myParams.date_range_to = me.users_date_range_to == null ? null : me.users_date_range_to.format();

        return myParams;
    };

    me.init = function () {
        me.loadUserRoles();

        me.initUsersTable();

        // handle export of data
        $('.app-content').on('click', '#export-form', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const params = me.usersTableQueryParams.call(me.$users_table.bootstrapTable('getOptions'));
            const visibleColumns = me.$users_table.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            if ($('#include-usage-stats').prop('checked')) {
                exportColumns.usage_date_range = 'Usage Date Range';
            }
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace(/<br>/g, ' ');
                }
            });
            params.columns = exportColumns;
            window.open(`${href}?${$.param(params)}`, 'Export');
        });

        // handle the Include Usage Stats button...
        $('.app-content').on('click', '#include-usage-toggle, #include-usage-stats', (e) => {
            e.preventDefault();
            if (+me.users_include_usage === 1) {
                $('#include-usage-stats').prop('checked', false);
                me.users_include_usage = 0;
                me.$users_table.bootstrapTable('refreshOptions', {
                    columns: +me.platform_id === 1 ? me.vjs_columns_without_usage : me.jr_columns_without_usage,
                });
            } else {
                me.$date_range_modal.modal({
                    backdrop: 'static',
                    keyboard: false,
                });
            }
            return false;
        });

        const dateRangeForm = $('<div>').html($('#date-range-form-template').html());

        const $continueButton = $('<button type="button" class="btn btn-blue" data-dismiss="modal">Continue</button>');

        $continueButton.on('click', (e) => {
            e.preventDefault();

            let errors = false;
            if ($('#date_range_from').val() === '') {
                $('#date_range_from').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#date_range_from').removeClass('is-invalid').addClass('is-valid');
            }
            if ($('#date_range_to').val() === '') {
                $('#date_range_to').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#date_range_to').removeClass('is-invalid').addClass('is-valid');
            }

            if (errors) {
                return false;
            }

            // if we're here, we have good dates, lets refresh the table with include_usage set to ON
            me.users_include_usage = 1;

            if (
                typeof $('#date_range_from').val() !== 'undefined'
                && $('#date_range_from').val() !== null
                && $('#date_range_from').val() !== ''
            ) {
                $('#date_range_from').val(moment($('#date_range_from').val()).utc().format());
                me.users_date_range_from = moment($('#date_range_from').val()).utc();
            }
            if (
                typeof $('#date_range_to').val() !== 'undefined'
                && $('#date_range_to').val() !== null
                && $('#date_range_to').val() !== ''
            ) {
                $('#date_range_to').val(moment($('#date_range_to').val()).utc().format());
                me.users_date_range_to = moment($('#date_range_to').val()).utc();
            }

            // refresh the table, with the usage columns shown...
            let columns;
            switch (me.platform_id) {
                case '1':
                    columns = { columns: me.vjs_columns_with_usage };
                    break;
                case '4':
                    columns = { columns: me.cp_columns_with_usage };
                    break;
                default:
                    columns = { columns: me.jr_columns_with_usage };
                    break;
            }
            me.$users_table.bootstrapTable('refreshOptions', columns);

            // set the checkbox to 'checked'
            $('#include-usage-stats').prop('checked', true);

            me.$date_range_modal.modal('hide');

            return true;
        });

        me.$date_range_modal = VjsAdmin.Modal.create({
            id: 'include-usage-modal',
            title: 'Choose Date Range for Usage Stats',
            body: dateRangeForm,
            footer: $continueButton,
            onShown() {
                VjsAdmin.initDateRangePickers($('#include-usage-modal'));
            },
        });

        me.$users_table.on('click', 'th.date-range-header', () => {
            me.$date_range_modal.modal({ backdrop: 'static', keyboard: false });
        });

        me.setupBulkEditLicenses();
    };

    me.loadUserRoles = function () {
        $.ajax({
            url: Slim.Router.pathFor('platforms.user_roles.json', {
                platform_id: me.platform_id,
            }),
            dataType: 'json',
            method: 'POST',
            async: true,
        }).done((responseData, textStatus, jqXHR) => {
            const { data } = jqXHR.responseJSON.data;
            $(data).each((i, role) => {
                $('#search-roles').append(`<option value="${role.role_id}">${role.name}</option>`);
            });
        });
    };

    me.initUsersTable = function () {
        me.$users_table.addClass('loading');

        const url = Slim.Router.pathFor('platforms.districts.licenses.users.list.json', {
            platform_id: me.platform_id,
            district_joint_guid: me.district_joint_guid,
            license_id: me.license_id,
        });

        let columns;
        switch (me.platform_id) {
            case '1':
                columns = me.vjs_columns_without_usage;
                break;
            case '4':
                columns = me.cp_columns_without_usage;
                break;
            default:
                columns = me.jr_columns_without_usage;
                break;
        }

        me.$users_table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#users-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                let active = '';
                switch (this.search_active) {
                    case '':
                    case 'all':
                        active = ' ';
                        break;
                    case 1:
                    case '1':
                        active = '<em>active</em> ';
                        break;
                    case 0:
                    case '0':
                        active = '<em>inactive</em> ';
                        break;
                    default:
                        break;
                }

                let type = '';
                switch (this.search_roles) {
                    case '':
                    case 'all':
                        type = 'users of any role';
                        break;
                    case 'users':
                        type = 'users';
                        break;
                    case 'admins':
                        type = 'admins';
                        break;
                    default:
                        type = `${$('#search-roles option:selected').text()}s`;
                        break;
                }
                return `No ${active}<strong>${type}</strong> ${typeof searchTerm !== 'undefined' && searchTerm !== '' ? ` matching search term <strong>\`${searchTerm}\`</strong>` : ''
                    } in this license.`;
            },
            showColumns: true,
            pageList: [25, 50, 100, 250, 500],
            buttonsAlign: 'right',
            idField: 'user_id',
            toolbar: '#report-toolbar',
            sortName: 'date_created',
            sortOrder: 'desc',
            search_roles: 'all',
            search_active: 1,
            height: me.users_table_height,
            clickToSelect: true,
            url,
            queryParams: me.usersTableQueryParams,
            columns,
            onUncheckAll() {
                me.selections = [];
                me.updateSelectedUsersCount();
            },
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    row.is_active = row.active;

                    row.checkbox = $.inArray(row.user_id, me.selections) !== -1;

                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    if (+row.has_logged_in === 0 || row.date_last_login == null) {
                        row.has_logged_in = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.has_logged_in = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    row.role = row.role.replace(/ /g, '&nbsp;');

                    row.time_spent = VjsAdmin.secondsToHoursMinutes(row.time_spent);

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.view')) {
                        const licenseUrl = Slim.Router.pathFor('platforms.districts.licenses.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.license_name = `<a href="${licenseUrl}">${row.license_name.replace(/ /g, '&nbsp;')}</a>`;
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.users.view')) {
                        const userUrl = Slim.Router.pathFor('platforms.districts.licenses.users.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: row.license_id,
                            user_id: row.user_id,
                        });
                        row.username = `<a href="${userUrl}">${row.username}</a>`;
                        if (row.first_name) {
                            row.first_name = `<a href="${userUrl}">${row.first_name}</a>`;
                        }
                        if (row.last_name) {
                            row.last_name = `<a href="${userUrl}">${row.last_name}</a>`;
                        }
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.users.edit.view') && me.platform_id !== '1') {
                        const userEditUrl = Slim.Router.pathFor('platforms.districts.licenses.users.edit.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: row.license_id,
                            user_id: row.user_id,
                        });
                        row.actions = `<a href="${userEditUrl}">Edit</a>`;
                    }
                });
                return formattedResult;
            },
            onPreBody(data) {
                VjsTable.tableDefaults().onPreBody.call(this, data);

                const thisTable = this;

                $('#search-active').off();
                $('#search-active').on('change', () => {
                    if ($('#search-active option:selected').val() !== '') {
                        thisTable.search_active = $('#search-active option:selected').val();
                    } else {
                        thisTable.search_active = null;
                    }
                    thisTable.updateUrl();
                    $('#users-table').bootstrapTable('refresh');
                });

                if (typeof this.default_search_active === 'undefined') {
                    this.default_search_active = this.search_active;
                }
                this.search_active = $.urlParam('search_active') ? $.urlParam('search_active') : this.default_search_active;
                $(`#search-active option[value=${this.search_active}]`).attr('selected', true);

                $('#search-roles').off();
                $('#search-roles').on('change', () => {
                    if ($('#search-roles option:selected').val() !== '') {
                        thisTable.search_roles = $('#search-roles option:selected').val();
                    } else {
                        thisTable.search_roles = null;
                    }
                    thisTable.updateUrl();
                    $('#users-table').bootstrapTable('refresh');
                });

                if (typeof this.default_search_roles === 'undefined') {
                    this.default_search_roles = this.search_roles;
                }
                this.search_roles = $.urlParam('search_roles') ? $.urlParam('search_roles') : this.default_search_roles;
                $(`#search-roles option[value=${this.search_roles}]`).attr('selected', true);
            },
            onLoadSuccess(data) {
                VjsTable.tableDefaults().onLoadSuccess.call(this, data);
                me.updateDateRangeHeader();
            },
            updateUrl() {
                const queryParams = {};
                if (this.search_active !== this.default_search_active) {
                    queryParams.search_active = this.search_active;
                }
                if (this.search_roles !== this.default_search_roles) {
                    queryParams.search_roles = this.search_roles;
                }
                VjsTable.tableDefaults().updateUrl.call(this, queryParams);
            },
            onSort(name, order) {
                VjsTable.tableDefaults().onSort.call(this, name, order);
                me.updateDateRangeHeader();
            },
            onColumnSwitch() {
                me.$users_table.bootstrapTable('refresh');
                me.updateDateRangeHeader();
            },
            rowStyle(row) {
                let classes = '';

                if (+row.is_active === 0) {
                    classes += 'danger ';
                }
                if (+row.archived === 1) {
                    classes += 'archived ';
                }

                return {
                    classes,
                };
            },
        });
    };

    me.updateDateRangeHeader = function () {
        if (
            typeof me.users_date_range_from !== 'undefined'
            && me.users_date_range_from != null
            && typeof me.users_date_range_to !== 'undefined'
            && me.users_date_range_to != null
        ) {
            me.$users_table
                .find('th.date-range-header')
                .html(
                    `<a href="#"><i class="fa fa-calendar" aria-hidden="true"></i> ${me.users_date_range_from.format(
                        'l',
                    )} to  <i class="fa fa-calendar" aria-hidden="true"></i> ${me.users_date_range_to.format('l')}</a>`,
                );
        } else if (typeof me.users_date_range_from !== 'undefined' && me.users_date_range_from != null) {
            me.$users_table
                .find('th.date-range-header')
                .html(`<a href="#"><i class="fa fa-calendar" aria-hidden="true"></i> ${me.users_date_range_from.format('l')} to Now</a>`);
        }
    };

    me.vjs_columns_without_usage = [
        {
            field: 'checkbox',
            title: 'Delete',
            checkbox: true,
            visible: false,
            formatter(value, row) {
                if (+row.is_active === 0) {
                    return {
                        disabled: true,
                    };
                }
                return value;
            },
        },
        {
            title: 'Active',
            field: 'active',
            align: 'center',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'Main License',
            field: 'license_name',
            align: 'left',
            valign: 'middle',
            visible: true,
            sortable: true,
            formatter(value, row) {
                return row.is_main_license
                    ? value
                    : `<span style='white-space: nowrap;'><i class='fa fa-warning text-warning' title='Different Main License'></i> &nbsp;${value}</span>`;
            },
        },
        {
            title: 'Username',
            field: 'username',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'First Name',
            field: 'first_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Last Name',
            field: 'last_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Status',
            field: 'user_status',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Unique ID',
            field: 'unique_identifier',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Email',
            field: 'email',
            align: 'left',
            valign: 'middle',
            sortable: false,
        },
        {
            title: 'Rostering Type',
            field: 'rostering_type',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Rostering ID',
            field: 'rostering_id',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Role',
            field: 'role',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'City',
            field: 'city',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'State',
            field: 'state_code',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Grade',
            field: 'grade',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
            field: 'date_created',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
            field: 'date_modified',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Activity',
            field: 'date_last_activity',
            align: 'left',
            valign: 'middle',
            sortable: true,
            sorter: VjsAdmin.dateSorter,
        },
        {
            title: 'Has Logged In',
            field: 'has_logged_in',
            align: 'center',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '',
            field: 'actions',
            align: 'center',
            valign: 'middle',
            sortable: false,
            switchable: false,
        },
    ];

    me.vjs_columns_with_usage = [
        [
            {
                field: 'checkbox',
                title: 'Delete',
                checkbox: true,
                visible: false,
                rowspan: 2,
                formatter(value, row) {
                    if (+row.is_active === 0) {
                        return {
                            disabled: true,
                        };
                    }
                    return value;
                },
            },
            {
                title: 'Active',
                field: 'active',
                align: 'center',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'License',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Username',
                field: 'username',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'First Name',
                field: 'first_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Last Name',
                field: 'last_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Email',
                field: 'email',
                align: 'left',
                valign: 'middle',
                sortable: false,
                rowspan: 2,
            },
            {
                title: 'Videos<br>Watched',
                field: 'videos_watched',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'QA Videos<br>Watched',
                field: 'videos_watched_qa',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Logins',
                field: 'site_visits',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Time<br>Spent',
                field: 'time_spent',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Videos<br>Watched',
                field: 'videos_watched',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'QA Videos<br>Watched',
                field: 'videos_watched_qa',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Career<br>Journals',
                field: 'career_journals',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Assessments<br>Completed',
                field: 'assessments_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Assignments<br>Completed',
                field: 'assignments_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Résumés<br>Completed',
                field: 'resumes_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Quizzes<br>Completed',
                field: 'quiz_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Goals<br>Created',
                field: 'goals_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Status',
                field: 'user_status',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Unique ID',
                field: 'unique_identifier',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Rostering Type',
                field: 'rostering_type',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Rostering ID',
                field: 'rostering_id',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Role',
                field: 'role',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'City',
                field: 'city',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'State',
                field: 'state_code',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Grade',
                field: 'grade',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                field: 'date_modified',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Activity',
                field: 'date_last_activity',
                align: 'left',
                valign: 'middle',
                sortable: true,
                sorter: VjsAdmin.dateSorter,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Login',
                field: 'date_last_login',
                align: 'left',
                visible: false,
                valign: 'middle',
                sortable: true,
                sorter: VjsAdmin.dateSorter,
                rowspan: 2,
            },
            {
                title: 'Has Logged In',
                field: 'has_logged_in',
                align: 'venter',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                switchable: false,
                rowspan: 2,
            },
        ],
        [
            {
                title: 'Date Range',
                field: 'date_range',
                align: 'center',
                valign: 'middle',
                visible: false,
                sortable: false,
                colspan: 3,
                class: 'date-range-header',
            },
        ],
    ];

    me.cp_columns_with_usage = [
        [
            {
                field: 'checkbox',
                title: 'Delete',
                checkbox: true,
                visible: false,
                rowspan: 2,
                formatter(value, row) {
                    if (+row.is_active === 0) {
                        return {
                            disabled: true,
                        };
                    }
                    return value;
                },
            },
            {
                title: 'Active',
                field: 'active',
                align: 'center',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'License',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Username',
                field: 'username',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'First Name',
                field: 'first_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Last Name',
                field: 'last_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Email',
                field: 'email',
                align: 'left',
                valign: 'middle',
                sortable: false,
                rowspan: 2,
            },
            {
                title: 'Logins',
                field: 'site_visits',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Time<br>Spent',
                field: 'time_spent',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Status',
                field: 'user_status',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Unique ID',
                field: 'unique_identifier',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Rostering Type',
                field: 'rostering_type',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Rostering ID',
                field: 'rostering_id',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Role',
                field: 'role',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'City',
                field: 'city',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'State',
                field: 'state_code',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Grade',
                field: 'current_grade.name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
            },
            {
                title: 'Grad Year',
                field: 'grad_year',
                align: 'right',
                valign: 'middle',
                sortable: true,
                visible: false,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                field: 'date_modified',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Activity',
                field: 'date_last_activity',
                align: 'left',
                valign: 'middle',
                sortable: true,
                sorter: VjsAdmin.dateSorter,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Login',
                field: 'date_last_login',
                align: 'left',
                visible: false,
                valign: 'middle',
                sortable: true,
                sorter: VjsAdmin.dateSorter,
                rowspan: 2,
            },
            {
                title: 'Has Logged In',
                field: 'has_logged_in',
                align: 'venter',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                switchable: false,
                rowspan: 2,
            },
        ],
        [
            {
                title: 'Date Range',
                field: 'date_range',
                align: 'center',
                valign: 'middle',
                visible: false,
                sortable: false,
                colspan: 3,
                class: 'date-range-header',
            },
        ],
    ];

    me.jr_columns_without_usage = [
        {
            field: 'checkbox',
            title: 'Delete',
            checkbox: true,
            visible: false,
        },
        {
            title: 'Active',
            field: 'active',
            align: 'center',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'License',
            field: 'license_name',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'Username',
            field: 'username',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'First Name',
            field: 'first_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Last Name',
            field: 'last_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Status',
            field: 'user_status',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Unique ID',
            field: 'unique_identifier',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Email',
            field: 'email',
            align: 'left',
            valign: 'middle',
            sortable: false,
        },
        {
            title: 'Rostering Type',
            field: 'rostering_type',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Rostering ID',
            field: 'rostering_id',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Role',
            field: 'role',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Grade',
            field: 'grade',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Grad Year',
            field: 'graduation_year',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
            field: 'date_created',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
            field: 'date_modified',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Activity',
            field: 'date_last_activity',
            align: 'left',
            valign: 'middle',
            sortable: true,
            sorter: VjsAdmin.dateSorter,
        },
        {
            title: 'Has Logged In',
            field: 'has_logged_in',
            align: 'venter',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '',
            field: 'actions',
            align: 'center',
            valign: 'middle',
            sortable: false,
            switchable: false,
        },
    ];

    me.cp_columns_without_usage = [
        {
            field: 'checkbox',
            title: 'Delete',
            checkbox: true,
            visible: false,
            formatter(value, row) {
                if (+row.is_active === 0) {
                    return {
                        disabled: true,
                    };
                }
                return value;
            },
        },
        {
            title: 'Active',
            field: 'active',
            align: 'center',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'License',
            field: 'license_name',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'Username',
            field: 'username',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'First Name',
            field: 'first_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Last Name',
            field: 'last_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Status',
            field: 'user_status',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Unique ID',
            field: 'unique_identifier',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Email',
            field: 'email',
            align: 'left',
            valign: 'middle',
            sortable: false,
        },
        {
            title: 'Rostering Type',
            field: 'rostering_type',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Rostering ID',
            field: 'rostering_id',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Active Role',
            field: 'role',
            align: 'left',
            valign: 'middle',
            sortable: true,
            formatter(value) {
                switch (value) {
                    case 'license_admin':
                        return 'School Admin';
                    default:
                        return _.startCase(value.replace('_', ' '));
                }
            },
        },
        {
            title: 'Roles',
            field: 'roles',
            align: 'left',
            valign: 'middle',
            sortable: true,
            formatter(value) {
                return value
                    .map((role) => {
                        switch (role.role) {
                            case 'license_admin':
                                return 'School Admin';
                            default:
                                return _.startCase(role.role.replace('_', ' '));
                        }
                    })
                    .join(', ');
            },
        },
        {
            title: 'Grade',
            field: 'current_grade.name',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Grad Year',
            field: 'grad_year',
            align: 'right',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
            field: 'date_created',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
            field: 'date_modified',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Activity',
            field: 'date_last_activity',
            align: 'left',
            valign: 'middle',
            sortable: true,
            sorter: VjsAdmin.dateSorter,
        },
        {
            title: 'Has Logged In',
            field: 'has_logged_in',
            align: 'venter',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '',
            field: 'actions',
            align: 'center',
            valign: 'middle',
            sortable: false,
            switchable: false,
        },
    ];

    me.jr_columns_with_usage = [
        [
            {
                field: 'checkbox',
                title: 'Delete',
                checkbox: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Active',
                field: 'active',
                align: 'center',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'License',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Username',
                field: 'username',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'First Name',
                field: 'first_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Last Name',
                field: 'last_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Email',
                field: 'email',
                align: 'left',
                valign: 'middle',
                sortable: false,
                rowspan: 2,
            },
            {
                title: 'Videos<br>Watched',
                field: 'videos_watched',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Cluster<br>Videos<br>Watched',
                field: 'videos_watched_cluster',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Career<br>Videos<br>Watched',
                field: 'videos_watched_career',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'QA<br>Videos<br>Watched',
                field: 'videos_watched_career_qa',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Logins',
                field: 'site_visits',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Time<br>Spent',
                field: 'time_spent',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Lessons<br>Completed',
                field: 'lessons_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Assessments<br>Completed',
                field: 'assessments_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Status',
                field: 'user_status',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Unique ID',
                field: 'unique_identifier',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Rostering Type',
                field: 'rostering_type',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Rostering ID',
                field: 'rostering_id',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Role',
                field: 'role',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Grade',
                field: 'grade',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Grad Year',
                field: 'graduation_year',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                field: 'date_modified',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Activity',
                field: 'date_last_activity',
                align: 'left',
                valign: 'middle',
                sortable: true,
                sorter: VjsAdmin.dateSorter,
                rowspan: 2,
            },
            {
                title: 'Has Logged In',
                field: 'has_logged_in',
                align: 'venter',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                switchable: false,
                rowspan: 2,
            },
        ],
        [
            {
                title: 'Date Range',
                field: 'date_range',
                align: 'center',
                valign: 'middle',
                visible: false,
                sortable: false,
                colspan: 3,
                class: 'date-range-header',
            },
        ],
    ];

    me.setupBulkEditLicenses = function () {
        if (VjsAdmin.hasPermission('platforms.districts.users.bulk_edit.post')) {
            me.$bulk_edit_buttons = $('<div class="columns columns-right btn-group float-right"></div>');
            me.$bulk_edit_enable_button = $(
                '<button class="btn btn-hollow-pink" type="button" name="refresh" aria-label="refresh" title="Enable Bulk Edit Mode"><i class="fa-regular fa-square-check" aria-hidden="true"></i> Enable Bulk Edit Mode</button>',
            );
            me.$bulk_edit_edit_button = $(
                '<button class="btn btn-hollow-pink" type="button" name="refresh" aria-label="refresh" data-toggle="tooltip" data-placement="top" title="Select Users to Bulk Edit, then click here to choose an action" style="display:none;">Bulk Edit <span class="selected-users-count">0 Users</span></button>',
            );
            me.$bulk_edit_done_button = $(
                '<button class="btn btn-hollow-dark-gray" type="button" name="refresh" aria-label="refresh" title="Done" style="display:none;">Done</button>',
            );
            me.$bulk_edit_enable_button.on('click', me.enableBulkEditMode);
            me.$bulk_edit_done_button.on('click', me.disableBulkEditMode);

            // when they click on the bulk edit button, show the modal
            me.$bulk_edit_edit_button.on('click', () => {
                if (me.selections.length > 0) {
                    me.updateSelectedUsersCount();
                    me.$bulk_edit_edit_button.tooltip('hide');
                    $('#bulk-edit-action').val('').trigger('change');
                    me.$bulk_edit_modal.modal({
                        backdrop: 'static',
                        keyboard: false,
                    });
                }
            });
            if (me.platform_id !== '1') {
                me.$bulk_edit_buttons.append(me.$bulk_edit_enable_button);
                me.$bulk_edit_buttons.append(me.$bulk_edit_edit_button);
                me.$bulk_edit_buttons.append(me.$bulk_edit_done_button);
            }

            const $bulkEditUsersForm = $('<div>').html($('#bulk-edit-users-form-template').html());
            const $saveButton = $(
                `<button type="button" class="btn btn-blue" data-dismiss="modal">Save Changes for <span class="selected-users-count">${me.selections.length} Users</span></button>`,
            );
            const $cancelButton = $('<button type="button" class="btn btn-hollow-dark-gray" data-dismiss="modal">Cancel</button>');

            $saveButton.on('click', (e) => {
                e.preventDefault();
                $('#bulk-edit-modal .modal-body .alert').remove();
                $('#bulk-edit-modal .modal-body input').removeClass('is-invalid').removeClass('is-valid');
                const action = $('#bulk-edit-action').val();
                const data = {};
                data.users = me.selections;
                data.action = action;
                const errors = [];

                // validate form
                switch (action) {
                    case 'license':
                        if ($('#bulk_edit_license_id').val() === '') {
                            $('#bulk_edit_license_id').removeClass('is-valid').addClass('is-invalid');
                            errors.push("You must select a dang ol' license!");
                        } else {
                            $('#bulk_edit_license_id').removeClass('is-invalid').addClass('is-valid');
                            data.license_id = $('#bulk_edit_license_id').val();
                        }
                        break;
                    case 'password':
                        if ($('#bulk_edit_user_password').val() === '') {
                            $('#bulk_edit_user_password').removeClass('is-valid').addClass('is-invalid');
                            errors.push('You must enter a password!');
                        } else if ($('#bulk_edit_user_password_confirm').val() === '') {
                            $('#bulk_edit_user_password_confirm').removeClass('is-valid').addClass('is-invalid');
                            errors.push('You must enter the password again!');
                        } else if ($('#bulk_edit_user_password').val() !== $('#bulk_edit_user_password_confirm').val()) {
                            $('#bulk_edit_user_password').removeClass('is-valid').addClass('is-invalid');
                            $('#bulk_edit_user_password_confirm').removeClass('is-valid').addClass('is-invalid');
                            errors.push('You must enter the password the same BOTH times!');
                        } else {
                            $('#bulk_edit_user_password').removeClass('is-invalid').addClass('is-valid');
                            $('#bulk_edit_user_password_confirm').removeClass('is-invalid').addClass('is-valid');
                            data.password = $('#bulk_edit_user_password').val();
                        }
                        break;
                    case 'delete':
                        if ($('#bulk_edit_delete-yes').prop('checked') !== true) {
                            $('#bulk_edit_delete-yes').removeClass('is-valid').addClass('is-invalid');
                            errors.push('You must be TOTALLY sure!');
                        } else {
                            $('#bulk_edit_delete-yes').removeClass('is-invalid').addClass('is-valid');
                            data.sure = true;
                        }
                        break;
                    case 'merge':
                        {
                            const $selectMainUserId = $('#select-main-user-id');
                            const $selectRosteringUserId = $('#select-rostering-user-id');
                            const $inputRosteringType = $('#input-rostering-type');
                            const $selectSsoUserId = $('#select-sso-user-id');
                            if ($selectMainUserId.val() === '') {
                                $selectMainUserId.removeClass('is-valid').addClass('is-invalid');
                                errors.push('Choose User must be filled out!');
                            } else {
                                $selectMainUserId.removeClass('is-invalid').addClass('is-valid');
                                data.main_user_id = $selectMainUserId.val();
                            }
                            if ($selectRosteringUserId.val() === '' && $selectRosteringUserId.find('option').length > 1) {
                                $selectRosteringUserId.removeClass('is-valid').addClass('is-invalid');
                                errors.push('Choose Rostering must be filled out!');
                            } else {
                                $selectRosteringUserId.removeClass('is-invalid').addClass('is-valid');
                                data.rostering_user_id = $selectRosteringUserId.val();
                                data.rostering_type = $inputRosteringType.val();
                            }
                            if ($selectSsoUserId.val() === '' && $selectSsoUserId.find('option').length > 1) {
                                $selectSsoUserId.removeClass('is-valid').addClass('is-invalid');
                                errors.push('Choose SSO must be filled out!');
                            } else {
                                $selectSsoUserId.removeClass('is-invalid').addClass('is-valid');
                                data.sso_user_id = $selectSsoUserId.val();
                            }
                        }
                        break;
                    case 'ignore-updates':
                        if ($('#bulk-edit-users-ignore-updates-checkbox').prop('checked') !== true) {
                            $('#bulk-edit-users-ignore-updates-checkbox').removeClass('is-valid').addClass('is-invalid');
                            errors.push('You must be TOTALLY sure!');
                        } else {
                            $('#bulk-edit-users-ignore-updates-checkbox').removeClass('is-invalid').addClass('is-valid');
                            data.sure = true;
                        }
                        break;
                    default:
                        break;
                }

                if (errors.length > 0) {
                    $.each(errors, (i, error) => {
                        $('#bulk-edit-modal .modal-body').prepend(
                            `<div class="alert alert-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${error}</div>`,
                        );
                    });
                    return false;
                }
                $('body').css('cursor', 'wait');
                $('.app').addClass('light-blur');
                $('#ajax-progress-indicator').fadeIn();
                $.ajax({
                    url: Slim.Router.pathFor('platforms.districts.users.bulk_edit.post', {
                        platform_id: me.platform_id,
                        district_joint_guid: me.district_joint_guid,
                    }),
                    dataType: 'json',
                    method: 'POST',
                    data,
                    async: true,
                })
                    .done((responseData) => {
                        if (typeof responseData.meta.failures !== 'undefined' && responseData.meta.failures > 0) {
                            $.each(responseData.data.failure, (i, message) => {
                                me.$bulk_edit_response_modal
                                    .find('.modal-body')
                                    .append(
                                        `<div class="alert alert-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${message}</div>`,
                                    );
                            });
                            $.each(responseData.data.success, (i, message) => {
                                me.$bulk_edit_response_modal
                                    .find('.modal-body')
                                    .append(
                                        `<div class="alert alert-success" role="alert"><i class="fa fa-thumbs-up" aria-hidden="true"></i> ${message}</div>`,
                                    );
                            });
                            me.$bulk_edit_response_modal.modal({
                                backdrop: 'static',
                                keyboard: false,
                            });
                        }
                    })
                    .fail((jqXHR, textStatus, errorThrown) => {
                        if (+jqXHR.status === 400) {
                            me.$bulk_edit_response_modal
                                .find('.modal-body')
                                .prepend(
                                    `<div class="alert alert-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${jqXHR.responseJSON.message}</div>`,
                                );
                        } else {
                            me.$bulk_edit_response_modal
                                .find('.modal-body')
                                .prepend(
                                    `<div class="alert alert-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${errorThrown}</div>`,
                                );
                        }
                        me.$bulk_edit_response_modal.modal({
                            backdrop: 'static',
                            keyboard: false,
                        });
                    })
                    .always(() => {
                        $('body').css('cursor', 'default');
                        $('.app').removeClass('light-blur');
                        $('#ajax-progress-indicator').fadeOut();
                        // if we deleted the users, clear out the selections array
                        if (action === 'delete' || action === 'merge') {
                            me.selections = [];
                        }
                        me.updateSelectedUsersCount();
                        me.disableBulkEditMode();
                        me.$users_table.bootstrapTable('refresh', {
                            silent: true,
                        });
                        me.$bulk_edit_modal.modal('hide');
                    });

                me.$bulk_edit_edit_button.prop('disabled', false);
                me.updateSelectedUsersCount();
                return false;
            });

            $cancelButton.on('click', () => {
                $('#bulk-edit-modal .modal-body .alert').remove();
                $('#bulk-edit-modal .modal-body input').removeClass('is-invalid').removeClass('is-valid');
                me.$bulk_edit_edit_button.prop('disabled', false);
                me.updateSelectedUsersCount();
            });

            const $modalFooter = $('<div></div>');
            $modalFooter.append($cancelButton);
            $modalFooter.append($saveButton);

            if (me.$bulk_edit_modal == null) {
                me.$bulk_edit_modal = VjsAdmin.Modal.create({
                    id: 'bulk-edit-modal',
                    title: `Bulk Edit <span class="selected-users-count">${me.selections.length} Users</span>`,
                    body: $bulkEditUsersForm,
                    footer: $modalFooter,
                    no_close: true,
                    onShown() {
                        me.updateSelectedUsersCount();
                        $('#bulk-edit-action').on('change', function () {
                            $('#bulk-edit-modal .modal-body .alert').remove();
                            const action = $(this).val();
                            $('#custom-form-fields')
                                .html('')
                                .append($(`#bulk-edit-users-${action}`).html());
                            if (action === '') {
                                $('#custom-form-fields-container').hide();
                            } else {
                                if (action === 'license') {
                                    me.initLicensesTable();
                                }
                                if (action === 'merge') {
                                    if (me.selections.length !== 2) {
                                        VjsUtility.Notification.error({
                                            text: 'You must choose 2 Users in order to merge.',
                                            time: 6000, // in milliseconds
                                        });
                                        return false;
                                    }
                                    new me.MergeUsers().fetch({
                                        user_id1: me.selections[0],
                                        user_id2: me.selections[1],
                                    });
                                }
                                $('#custom-form-fields-container').show();
                            }
                        });
                    },
                });
            }

            const $closeButton = $('<button type="button" class="btn btn-hollow-dark-gray" data-dismiss="modal">Close</button>');

            if (me.$bulk_edit_response_modal == null) {
                me.$bulk_edit_response_modal = VjsAdmin.Modal.create({
                    id: 'bulk-edit-response-modal',
                    title: 'Bulk Edit Results',
                    body: '',
                    footer: $closeButton,
                    onHidden() {
                        $('#bulk-edit-response-modal .modal-body .alert').remove();
                    },
                });
            }

            me.$users_table.on('check.bs.table check-all.bs.table uncheck.bs.table uncheck-all.bs.table', (e, rows) => {
                const userIds = $.map(!$.isArray(rows) ? [rows] : rows, (row) => row.user_id);
                if (e.type === 'check' || e.type === 'check-all') {
                    if (userIds.length + me.selections.length > me.bulk_delete_max) {
                        window.alert('You have reached the max # of users to bulk delete at one time!');
                        me.$users_table.bootstrapTable('uncheckBy', {
                            field: 'user_id',
                            values: _.difference(userIds, me.selections),
                        });
                        return false;
                    }
                }
                const func = $.inArray(e.type, ['check', 'check-all']) > -1 ? 'union' : 'difference';
                me.selections = _[func](me.selections, userIds);
                me.updateSelectedUsersCount();
            });

            me.addButtons();
        }
    };

    me.updateSelectedUsersCount = function () {
        $('.selected-users-count').text(`${me.selections.length} User${+me.selections.length === 1 ? '' : 's'}`);
    };

    me.enableBulkEditMode = function () {
        me.updateSelectedUsersCount();
        me.$bulk_edit_enable_button.hide();
        me.$bulk_edit_edit_button.show();
        me.$bulk_edit_edit_button.tooltip('show');
        me.$bulk_edit_done_button.show();
        me.$users_table.bootstrapTable('showColumn', 'checkbox');
        me.$users_table.bootstrapTable('hideColumn', 'actions');
        me.updateDateRangeHeader();
    };

    me.disableBulkEditMode = function () {
        me.updateSelectedUsersCount();
        me.$bulk_edit_enable_button.show();
        me.$bulk_edit_edit_button.hide();
        me.$bulk_edit_done_button.hide();
        me.$users_table.bootstrapTable('hideColumn', 'checkbox');
        me.$users_table.bootstrapTable('showColumn', 'actions');
        me.updateDateRangeHeader();
    };

    me.addButtons = function () {
        me.$users_table.closest('.bootstrap-table').find('.fixed-table-toolbar .columns-right').after(me.$bulk_edit_buttons);
    };

    me.licensesTableQueryParams = function (params) {
        const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
        myParams.sort_order = me.districts_sort_order;
        myParams.order_by = me.districts_order_by;
        myParams.search_term = $('#bulk-edit-users-form .fixed-table-toolbar .search > input').val();
        return myParams;
    };

    me.initLicensesTable = function () {
        const $licensesTable = $('#licenses-table');
        $licensesTable.addClass('loading');

        $licensesTable.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#licenses-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                return `No licenses ${typeof searchTerm !== 'undefined' ? ` matching search term \`${searchTerm}\`` : ''}`;
            },
            queryParams: me.licensesTableQueryParams,
            toolbar: null,
            toolbarAlign: 'left',
            sortName: 'license_id',
            height: me.licenses_table_height,
            singleSelect: true,
            clickToSelect: true,
            maintainSelected: true,
            onCheck(row) {
                $('#bulk_edit_license_id').val(row.license_id);
            },
            url: Slim.Router.pathFor('platforms.districts.licenses.list.json', {
                platform_id: me.platform_id,
                district_joint_guid: me.district_joint_guid,
            }),
            columns: [
                {
                    title: '',
                    field: 'selected',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    radio: true,
                },
                {
                    title: 'ID',
                    field: 'license_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Name',
                    field: 'license_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'City',
                    field: 'city',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, row) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    row.is_active = row.active;
                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }
                });
                return formattedResult;
            },
            onLoadSuccess(data) {
                VjsTable.tableDefaults().onLoadSuccess.call(this, data);
                me.updateDateRangeHeader();
            },
            onSort(name, order) {
                VjsTable.tableDefaults().onSort.call(this, name, order);
                me.licenses_order_by = name;
                me.licenses_sort_order = order;
            },
        });
    };

    me.MergeUsers = VjsUtility.View.extend({
        parent: '#merge-users-container',
        templateUrl: '/assets/templates/platforms/districts/bulk-merge-users.html',
        dataUrl: `/platforms/${me.platform_id}/districts/${me.district_joint_guid}/users/merge/`,
        events: {
            'change #select-main-user-id': 'changeMainUserId',
            'change #select-rostering-user-id': 'changeRosteringUserId',
            'change #select-sso-user-id': 'changeSsoUserId',
        },
        changeMainUserId(e) {
            const userId = $(e.currentTarget).val();
            $('.main-user-container').removeClass('alert-success');
            $(`#user-${userId}`).addClass('alert-success');
        },
        changeRosteringUserId(e) {
            const userId = $(e.currentTarget).val();
            const $container = $(`#user-rostering-${userId}`);
            $('.rostering-container').removeClass('alert-success');
            $container.addClass('alert-success');
            $('#input-rostering-type').val($container.data('rostering-type'));
        },
        changeSsoUserId(e) {
            const userId = $(e.currentTarget).val();
            $('.sso-container').removeClass('alert-success');
            $(`#user-sso-${userId}`).addClass('alert-success');
        },
    });

    return {
        init: me.init,
    };
})();
